// Hämtar fil via document-proxy edge function (kringgår adblockers) och
// öppnar den i ny flik som blob URL. Returnerar en Promise som resolvar när
// nedladdningen lyckats (eller rejectar).
export async function downloadDocument(filePath: string): Promise<void> {
  const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/document-proxy?path=${encodeURIComponent(filePath)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch document: ${res.status}`);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  // Frigör efter en stund så fliken hinner ladda
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
}

/**
 * Extraherar storage-path från en publik Supabase URL.
 * Ex: ".../storage/v1/object/public/documents/Allmanna_villkor/file.pdf"
 *  → "Allmanna_villkor/file.pdf"
 * Om input inte är en publik URL antas det redan vara en path.
 */
export function extractDocumentPath(urlOrPath: string): string {
  const marker = '/storage/v1/object/public/documents/';
  const idx = urlOrPath.indexOf(marker);
  if (idx >= 0) return decodeURIComponent(urlOrPath.slice(idx + marker.length));
  return urlOrPath;
}
